import './ProductGrid.scss';
import Component from './ProductGrid.js';
export default Component;
